import { Table } from "@ttc3k/trekker";
import { Box } from "styled-system/jsx";
import { Tag } from "gql/generated";
import { ConsumingOverlayPageProps, OverlayPage } from "../OverlayPage";
import { useTranslation } from "react-i18next";
import { useBookerContext } from "widgets/booker/contexts";
import { getMultilingualString } from "shared/utils";

type AmenitiesPageProps = ConsumingOverlayPageProps & {
  amenities: Tag[];
};

export const AmenitiesPage = ({
  amenities,
  onClose,
  ...rest
}: AmenitiesPageProps) => {
  const { language } = useBookerContext();
  const { t } = useTranslation("booker", { keyPrefix: "AMENITIES_PAGE" });
  return (
    <OverlayPage
      title={t("TITLE")}
      subtitle={t("SUBTITLE")}
      onButtonClick={onClose}
      onClose={onClose}
      {...rest}
    >
      <Box mt={"400"}>
        <Table.Root>
          <Table.Body>
            {amenities.map(amenity => (
              <Table.Row key={amenity._id}>
                <Table.Header>
                  {getMultilingualString(amenity.name, language)}
                </Table.Header>
              </Table.Row>
            ))}
          </Table.Body>
        </Table.Root>
      </Box>
    </OverlayPage>
  );
};
